{
  const Question = require('./question')

  const CLASS_DONE = 'is__done'
  const CLASS_REVEALED = 'is__revealed'
  const CLASS_CORRECT = 'is__correct'
  const CLASS_WRONG = 'is__wrong'
  const CLASS_SHIFTED_ANSWER = 'is__shiftedAnswer'
  const CLASS_VISIBLE_EXPLANATION = '.is__revealed .is__checked + .answerExplanation'
  const CLASS_SPREAD_HAS_RESERVED_PLACE = 'has__reservedPlace'

  // based on css-animation, see explanation.pcss
  const MIN_DIFF_FOR_SHIFTING_ANIMATION = 20

  const NOT_QUESTION_TEXT = '.caption, .sidenote'
  const CAPTION_TEXT = '.caption-text'

  class StandaloneQuestionTest {
    constructor($el) {
      this.$el = $el
      this.id = this.$el.data('id')
      this.revealId = [this.id, 'testRevealed'].join('.')
      this.$spread = $el.closest('.js__spread')
      this.$answers = this.$el.find('.answer')
      this.$explanations = this.$el.find('.explanation')

      this.$spread.on('spreadCreated', (e, spread) => {
        this.spread = spread

        this.initQuestion()
        this.addResetButton()
        this.check()
      })
    }

    get isDone() {
      return this.question.isReadyForCheck()
    }

    get isResizable() {
      return !this.$el.closest('.js__page').hasClass('is__sticky')
    }

    get hasReservedExplanationsHeight() {
      return this.spread.$el.hasClass(CLASS_SPREAD_HAS_RESERVED_PLACE)
    }

    initQuestion() {
      this.question = new Question(this.$el, this)
      this.question.init()
    }

    addResetButton() {
      const $button = $('<button class="question-reset">↻</button>')
        .on('click', this.reset.bind(this))
      const $questionTextNode = this.$el
        .find('.textNode')
        .filter((_, el) => !$(el).closest(NOT_QUESTION_TEXT).length)
        .first()

      const hasQuestionWrittenInCaption = !$questionTextNode.length
      const $buttonBase =
        hasQuestionWrittenInCaption ? this.$el.find(CAPTION_TEXT).first() : $questionTextNode

      $buttonBase.append($button)
    }

    reset() {
      this.question.erase()
      this.check()
      this.resizeSpread()
    }

    check() {
      this.markDone()
      this.markRevealed()

      if (!this.isDone) return

      this.question.lock()
      this.markCorrect()
      this.resizeSpread()
      this.markShiftedAnswers()
    }

    markDone() {
      this.$el.toggleClass(CLASS_DONE, this.isDone)
    }

    markRevealed() {
      this.$el.toggleClass(CLASS_REVEALED, this.isDone)
    }

    markCorrect() {
      this.$el
        .removeClass(CLASS_CORRECT)
        .removeClass(CLASS_WRONG)
        .addClass(this.question.isCorrect ? CLASS_CORRECT : CLASS_WRONG)
    }

    resizeSpread() {
      if (!this.isResizable) return

      if (this.hasReservedExplanationsHeight) return

      const lastSpreadHeight = this.spread.height

      this.spread.resize()

      this.spreadHeightDiff = Math.abs(this.spread.height - lastSpreadHeight)
    }

    markShiftedAnswers() {
      if (!this.isResizable) return

      const needsAnimation = this.spreadHeightDiff > MIN_DIFF_FOR_SHIFTING_ANIMATION
      const $visibleExplanations = this.$explanations.filter(CLASS_VISIBLE_EXPLANATION)

      if (!$visibleExplanations.length || !needsAnimation) return

      const topOfVisibleExplanations = $visibleExplanations.first().position().top

      this.$answers
        .removeClass(CLASS_SHIFTED_ANSWER)
        .filter((_, el) => $(el).position().top > topOfVisibleExplanations)
        .addClass(CLASS_SHIFTED_ANSWER)
    }
  }

  $('.js__question.is__standalone').each((_, el) => new StandaloneQuestionTest($(el)))
}
